import {AUTH_WITH_ERROR, AUTH_SET_USER, AUTH_SET_MAKING_LOGIN} from './types';
import {stateAuthentication} from '@/store/modules/authentication/state';
import { features } from './constants';
import { UserSessionStorageService } from '@/services/user-session-storage.service';
import {CountryType} from '@/enums/country.enum';

export interface payloadAuthSetUser {
  email: string;
  username: string;
  token: string;
  features: features[];
  idClient: number;
  userFullName: string;
  idVehicleType: number;
  country: CountryType;
}

export const mutations = {
  [AUTH_SET_USER]: (state: stateAuthentication, payload: payloadAuthSetUser) => {
    state.username = payload.username;
    state.email = payload.email;
    state.token = payload.token;
    state.features = payload.features;
    state.userFullName = payload.userFullName;
    state.idClient = payload.idClient;
    state.idVehicleType = payload.idVehicleType;
    state.country = payload.country;

    state.makingLogin = false;

    UserSessionStorageService.user = payload;
  },
  [AUTH_WITH_ERROR]: (state: stateAuthentication, payload: boolean) => {
    state.loginWithError = payload;
    state.makingLogin = false;
  },
  [AUTH_SET_MAKING_LOGIN]: (state: stateAuthentication, payload: boolean) => {
    state.makingLogin = payload;
  }
};
